import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';

const FavoriteItemCard = ({ item, onRemove }) => {
  const front = (item.files || []).find(f => f.for_show && f.type === 'image') || (item.files || []).find(f => f.type === 'image');
console.log('Rendering favorite itembbb:', item);
  return (
    <div className="favorite-item-card">
      <div className="favorite-item-border">
        <div className="favorite-item-media">
          {item ? <img src={item.url} alt={item.name} /> : <div className="favorite-item-placeholder">אין תמונה</div>}
        </div>
        <div className="favorite-item-footer">
          <div className="favorite-item-name">{item.name}</div>
          {item.features && item.features.length > 0 && (
            <div className="favorite-item-features">
              {item.types.slice(0, 2).map(f => <span key={f.id} className="favorite-feature-chip">{f.name}</span>)}
            </div>
          )}
          <div className="favorite-item-meta">מחיר: ₪{item.price} </div>
          <div className="favorite-item-meta">מתאים ל: {item.much_for}</div>
          {item.video && <div className="favorite-item-video">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                    stroke="#0cad5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" />
                    <polygon points="10,8 16,12 10,16" />
                  </svg></div>}
        </div>
        <button className="favorite-remove-btn" onClick={() => onRemove(item.id)}>✕</button>
      </div>
    </div>
  );
};

const Favorites = () => {
  const { user, removeFavorite, loadLikes } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const items = user?.likes || [];

  useEffect(() => {
    if (!user) { navigate('/', { replace: true }); return; }
    if (user?.id) {
      setLoading(true);
      loadLikes().finally(() => setLoading(false));
    }
  }, [ user?.id,navigate]);

  if (!user) return null;

  if (loading) {
    return (
      <div className="favorites-loading">
        טוען מוצרים אהובים...
      </div>
    );
  }

  const handleRemove = async (itemId) => {
    await removeFavorite(itemId);
  };

  return (
    <div className="favorites-container">
      <div className="favorites-header">
        <button style={{ border: "1px solid #ef4882", color:"#ef4882"}} onClick={() => navigate('/profile')} className="back-button">← חזרה לאזור אישי</button>
 <h3 style={{
  color: "#ef4882",
  display: "flex",
  justifyContent: "center",
  // alignItems: "center",
  gap: "8px"   // קצת רווח בין הכותרת לאייקון
}} > מוצרים שאהבתי  ({items.length})
  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#ef4882"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z" />
  </svg>
      </h3>      </div>

      {items.length === 0 && <div className="favorites-empty">אין מועדפים עדיין.</div>}

      <div className="favorites-grid">
        {items.map(it => (
          <FavoriteItemCard key={it.id} item={it} onRemove={handleRemove} />
        ))}
      </div>
    </div>
  );
};

export default Favorites;
